import { useMutation, useQueryClient } from 'react-query'

import { type RepoError } from '@webapp/infrastructure/interfaces/repositories/RepoError'
import { type CreateExternalBankAccountData } from '@webapp/platform/banking/business-logic/interfaces/IExternalBankAccountRepository'
import { type ExternalBankAccountConstructor } from '@webapp/platform/banking/entities/ExternalBankAccount'
import { EXTERNAL_BANK_ACCOUNT_LIST_BASE_KEY } from '@webapp/platform/banking/query-configs/externalBankAccount'
import { externalBankAccountRepository } from '../../../data-access/repositories/ExternalBankAccountRepository'

export const useMutateCreateExternalBankAccount = () => {
  const queryClient = useQueryClient()

  const mutation = useMutation<
    ExternalBankAccountConstructor,
    RepoError,
    CreateExternalBankAccountData
  >({
    mutationFn: (data) => externalBankAccountRepository.create(data),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: EXTERNAL_BANK_ACCOUNT_LIST_BASE_KEY,
      })
    },
  })

  return {
    mutateAsync: mutation.mutateAsync,
    isLoading: mutation.isLoading,
    isError: mutation.isError,
    error: mutation.error,
  }
}
